<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import AppShell from '@/components/AppShell.vue';
import ConfirmHost from '@/components/ConfirmHost.vue';
import ToastHost from '@/components/ToastHost.vue';

const route = useRoute();
const isBareRoute = computed(() => route.meta.bare === true);
</script>

<template>
  <AppShell v-if="!isBareRoute">
    <RouterView />
  </AppShell>
  <RouterView v-else />

  <ToastHost />
  <ConfirmHost />
</template>
